/** Heading for a drop-off list row: prefer displayNameOverride when the server allows it and the value is non-empty. */
export function getDropoffLocationDisplayName(
  useDisplayNameOverrideForLocationName: boolean | undefined,
  location: { name: string; displayNameOverride?: string }
): string {
  const override = location.displayNameOverride;
  if (
    useDisplayNameOverrideForLocationName &&
    override != null &&
    override.trim() !== ""
  ) {
    return override;
  }
  return location.name;
}
